import {Navigate, Route, Routes} from 'react-router-dom'
import Login from './pages/MainPages/User/Login'
import RequireAuth from './services/Main/RequireAuth'
import React, {useContext} from 'react'
import Dashboard from './pages/MainPages/Dashboard'
import InvoiceList from './pages/MainPages/Invoice/InvoiceList'
import ExpenseList from './pages/MainPages/Expense/ExpenseList'
import Base from './layout/Main/Base'
import {NoMatch} from './pages/MainPages/NoMatch'
import {UnitList} from './pages/MainPages/Unit/UnitList'
import RecoverPassword from './pages/MainPages/User/RecoverPassword'
import ChangePassword from './pages/MainPages/User/ChangePassword'
import Register from './pages/MainPages/User/Register'
import ProfileUpdate from './pages/MainPages/User/ProfileUpdate'
import CondoUpdate from './pages/MainPages/Condo/CondoUpdate'
import CondoList from './pages/MainPages/Condo/CondoList'
import ExpenseCreate from './pages/MainPages/Expense/ExpenseCreate'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFnsV3';
import {ptBR} from 'date-fns/locale/pt-BR'
import NewPassword from './pages/MainPages/User/NewPassword'
import SetFirstPassword from './pages/MainPages/User/SetFirstPassword'
import ExpenseUpdate from './pages/MainPages/Expense/ExpenseUpdate'
import InvoiceDetail from './pages/MainPages/Invoice/InvoiceDetail'
import FavIconTheme from './layout/Main/FavIconTheme'
import {BankStatement, BankTransfer} from './pages/MainPages/BankOperations'
import ExpenseDetails from './pages/MainPages/Expense/ExpenseDetails'
import {NotificationList} from './pages/MainPages/Notification/NotificationList'
import BankTransferReceiptTed from './pages/MainPages/BankOperations/BankTransferReceiptTed'
import Settings from './pages/MainPages/Settings/Settings'
import BlockFormSet from './pages/MainPages/Blocks/BlockFormSet'
import Category from './pages/MainPages/Category/Category'
import ServiceList from './pages/MainPages/services/ServiceList'
import ServiceCreate from './pages/MainPages/services/ServiceCreate'
import ServiceDetailAndUpdate from './pages/MainPages/services/ServiceDetailAndUpdate'
import BookingAreaList from './pages/MainPages/BookingArea/BookingAreaList'
import ComplaintCreate from './pages/MainPages/Complaints/ComplaintCreate'
import ComplaintMain from './pages/MainPages/Complaints/ComplaintMain'
import ComplaintDetailandUpdate from './pages/MainPages/Complaints/ComplaintDetailandUpdate'
import ComplaintList from './pages/MainPages/Complaints/ComplaintList'
import ComplaintCategory from './pages/MainPages/Complaints/ComplaintCategory'
import BookingCalendar from './pages/MainPages/Booking/BookingCalendar'
import UnitUserRegister from './pages/UnitUser/User/UnitUserRegister'
import UnitUserLogin from './pages/UnitUser/User/UnitUserLogin'
import UnitUserInvoiceList from './pages/UnitUser/Invoices/UnitUserInvoiceList'
import RequiredUnitAuth from './services/UnitUser/RequiredUnitAuth'
import BaseUnitUser from './layout/UnitUser/BaseUnitUser'
import UnitUserInvoiceDetail from './pages/UnitUser/Invoices/UnitUserInvoiceDetail'
import ChargeList from './pages/MainPages/Charge/ChargeList'
import ChargeDetail from './pages/MainPages/Charge/ChargeDetail'
import ChargeCreate from './pages/MainPages/Charge/ChargeCreate'
import MaintenanceCalendar from './pages/MainPages/Maintenance/MaintenanceCalendar'
import BillboardList from './pages/MainPages/Billboard/BillboardList'
import DocumentList from './pages/MainPages/Documents/DocumentList'
import Payment from './pages/MainPages/Payment/Payment'
import ManagementList from './pages/MainPages/Management/ManagementList'
import BankTransferReceiptPix from './pages/MainPages/BankOperations/BankTransferReceiptPix'
import RentList from './pages/MainPages/Rent/RentList'
import Context from './contexts/Context'
import RentForm from './pages/MainPages/Rent/RentForm'
import RentRecipientList from './pages/MainPages/RentRecipient/RentRecipientList'
import RentRecipientForm from './pages/MainPages/RentRecipient/RentRecipientForm'
import Impersonate from './pages/MainPages/User/Impersonate'
import UnitForm from "./pages/MainPages/Unit/UnitForm";
import Report from "./pages/MainPages/Report/Report";
import SignedRecipientTransferList from './pages/MainPages/SignedRecipientTransfer/SignedRecipentTransferList'
import SignedRecipientTransferDetail from './pages/MainPages/SignedRecipientTransfer/SignedRecipientTransferDetail'
import {getCondoType} from './services/Main/AuthStorage'
import PaymentList from "./pages/MainPages/Payment/PaymentList";
import RentalChargesList from './pages/MainPages/financial/RentalChargesList'
import Reajust from './pages/MainPages/financial/Reajust'
import LimitBankDetail from "./pages/MainPages/BankOperations/LimitBankDetail";
import CompanyList from './pages/MainPages/Admin/CompanyList'
import AdminDashboard from './pages/MainPages/Admin/AdminDashboard'
import AdminBase from './layout/Main/admin/AdminBase'
import CustomerInvoiceList from './pages/MainPages/Admin/CustomerInvoice/CustomerInvoiceList'
import CustomerInvoiceDetail from './pages/MainPages/Admin/CustomerInvoice/CustomerInvoiceDetail'
import RentContractAdminList from './pages/MainPages/Admin/Rent/RentList'
import RentReportList from './pages/MainPages/Report/RentList'
import UserAdminList from './pages/MainPages/Admin/UserList'
import RentalChargePayment from "./pages/MainPages/financial/RentalChargePayment";

import WhatsappConfig from "./pages/MainPages/Whatsapp/WhatsAppConfig";
import WebhookList from './pages/MainPages/Admin/WebhookList'
import BankTransferDetailTed from "./pages/MainPages/BankOperations/components/BankTransfer/BankTransferDetailTed";
import BankTransferDetailPix from "./pages/MainPages/BankOperations/components/BankTransfer/BankTransferDetailPix";
import CompanyRateList from './pages/MainPages/Admin/CompanyRateList'
import CompanyRateDetail from "./pages/MainPages/Admin/CompanyRateDetail";
import TransactionList from './pages/MainPages/Admin/TransactionList'
import CompanyDetail from "./pages/MainPages/Admin/CompanyDetail";
import Dimob from "./pages/MainPages/financial/Dimob";
import DimobDetail from "./pages/MainPages/financial/DimobDetail";
import InspectionList from "./pages/MainPages/Inspection/InspectionList";
import InspectionDetails from "./pages/MainPages/Inspection/InspectionDetails";
import AdminRentDashboard from "./pages/MainPages/Admin/AdminRentDashboard";
import RentRecipientDetail from "./pages/MainPages/RentRecipient/RentRecipientDetail";
import CustomerList from "./pages/MainPages/Customer/CustomerList";
import UserList from "./pages/MainPages/User/UserList";
import RentContractList from "./pages/MainPages/Rent/RentContractList";
import CategoryFee from "./pages/MainPages/Rent/CategoryFee";
import TemplateList from "./pages/MainPages/Sign/TemplateList";
import DocSignList from "./pages/MainPages/Sign/DocSignList";
import DocSignGate from "./pages/MainPages/Sign/DocSignGate";
import NewBankStatement from "./pages/MainPages/BankOperations/NewBankStatement";
import CashFlowDashboard from "./pages/MainPages/Dashboard/CashFlowDashboard";
import InvoiceCashFlow from "./pages/MainPages/Invoice/InvoiceCashFlow";
import PaymentCashFlow from "./pages/MainPages/Invoice/PaymentCashFlow";
import PaymentsList from "./pages/MainPages/Invoice/PaymentsList";
import PaymentsCreate from "./pages/MainPages/Invoice/PaymentsCreate";
import PaymentsDetail from "./pages/MainPages/Invoice/PaymentsDetail";
import ReceivablesList from "./pages/MainPages/Invoice/ReceivablesList";
import ReceivablesCreate from "./pages/MainPages/Invoice/ReceivablesCreate";
import ReceivablesDetail from "./pages/MainPages/Invoice/ReceivablesDetail";

import ContactsList from "./pages/MainPages/CashFlow/FinancialContacts/ContactsList";
import FinancialContactDetail from "./pages/MainPages/CashFlow/FinancialContacts/ContactDetail";
import ClientList from "./pages/MainPages/CashFlow/Contact/ClientList";
import EmployeeList from "./pages/MainPages/CashFlow/Contact/EmployeeList";
import SupplierList from "./pages/MainPages/CashFlow/Contact/SupplierList";
import BusinessPartnerList from "./pages/MainPages/CashFlow/Contact/BusinessPartnerList";
import ContactDetail from "./pages/MainPages/CashFlow/Contact/ContactDetail";

import TaskCenter from "./pages/MainPages/TaskCenter/TaskCenter";
import LogsViewer from "./components/Logs/Logs";
import AdminInvoiceList from "./pages/MainPages/Admin/Invoice/AdminInvoiceList";
import AdminSignedRecipientTransferList
    from "./pages/MainPages/Admin/SignedRecipientTransfer/AdminSignedRecipentTransferList";
import AdminMacroDashboard from "./pages/MainPages/Admin/AdminMacroDashboard";
import DigitalSignatureCreate from "./pages/MainPages/Sign/DigitalSignatureCreate";
import DigitalSignatureView from "./pages/MainPages/Sign/DigitalSignatureView";
import AIProviderConfigList from "./pages/MainPages/Admin/AIProviderConfig/AIProviderConfigList";
import AIProviderConfigForm from "./pages/MainPages/Admin/AIProviderConfig/AIProviderConfigForm";
import FeatureList from "./pages/MainPages/Admin/Feature/FeatureList";
import FeatureForm from "./pages/MainPages/Admin/Feature/FeatureForm";
import PlanList from "./pages/MainPages/Admin/Plan/PlanList";
import PlanForm from "./pages/MainPages/Admin/Plan/PlanForm";
import CompanyPlanManager from "./pages/MainPages/Admin/Plan/CompanyPlanManager";
import AdminAIAssistant from "./pages/MainPages/Admin/AIAssistant/AdminAIAssistant";

import BankHub from './pages/MainPages/BankHub'
import BankAccountList from "./pages/MainPages/BankAccounts/BankAccountList";
import StatementEntries from "./pages/MainPages/BankAccounts/StatementEntries";
import ImportHistory from "./pages/MainPages/BankAccounts/ImportHistory";
import FinancialConfig from "./pages/MainPages/financial/FinancialConfig";

import BaseTicket from './layout/Ticket/BaseTicket'
import TicketList from './pages/MainPages/Ticket/TicketList'
import TicketCreate from './pages/MainPages/Ticket/TicketCreate'
import TicketDetail from './pages/MainPages/Ticket/TicketDetail'
import AdminTicketList from './pages/MainPages/Admin/Ticket/AdminTicketList'
import AdminTicketDetail from './pages/MainPages/Admin/Ticket/AdminTicketDetail'
import AdminTicketDashboard from './pages/MainPages/Admin/Ticket/AdminTicketDashboard'
import AIKnowledgeBase from './pages/MainPages/Admin/Ticket/AIKnowledgeBase'

import TenantLogin from './pages/Tenant/Auth/TenantLogin'
import RequiredTenantAuth from './services/Tenant/RequiredTenantAuth'
import BaseTenant from './layout/Tenant/BaseTenant'
import TenantDashboard from './pages/Tenant/Dashboard/TenantDashboard'
import TenantInvoiceList from './pages/Tenant/Invoice/TenantInvoiceList'
import TenantInvoiceDetail from './pages/Tenant/Invoice/TenantInvoiceDetail'
import TenantChargeList from './pages/Tenant/Charge/TenantChargeList'
import TenantChargeDetail from './pages/Tenant/Charge/TenantChargeDetail'

function App () {
  const { user } = useContext(Context)
  const {
    is_superuser,
    perm_bank,
    perm_config,
    perm_financial,
    perm_billboard,
    perm_booking,
    perm_complain,
    perm_expense,
    perm_maintenance,
    perm_management,
    perm_rent
  } = user || {}

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <FavIconTheme/>
        <Routes>
          <Route path="/login" element={<Login/>}/>
          <Route path="/login/usuario" element={<UnitUserLogin/>}/>
          <Route path="/register" element={<Register/>}/>
          <Route path="/registrar/usuario" element={<UnitUserRegister/>}/>
          <Route path="/recuperar-senha" element={<RecoverPassword/>}/>
          <Route path="/nova-senha" element={<NewPassword/>}/>
          <Route path="/definir-senha" element={<SetFirstPassword/>}/>
          <Route path="/login/area-cliente" element={<TenantLogin/>}/>

          <Route element={<BaseTenant/>}>
            <Route element={<RequiredTenantAuth/>}>
              <Route path="/area-cliente/" element={<TenantDashboard/>}/>
              <Route path="/area-cliente/faturas/" element={<TenantInvoiceList/>}/>
              <Route path="/area-cliente/faturas/:id" element={<TenantInvoiceDetail/>}/>
              <Route path="/area-cliente/cobrancas/" element={<TenantChargeList/>}/>
              <Route path="/area-cliente/cobrancas/:id" element={<TenantChargeDetail/>}/>
            </Route>
          </Route>

          <Route element={<BaseTicket/>}>
            <Route element={<RequireAuth/>}>
              <Route path="/suporte" element={<TicketList/>}/>
              <Route path="/suporte/criar" element={<TicketCreate/>}/>
              <Route path="/suporte/:id" element={<TicketDetail/>}/>
            </Route>
          </Route>

          <Route element={<BaseUnitUser/>}>
            <Route element={<RequiredUnitAuth/>}>
              {user &&
                <>
                  <Route path="/usuario/perfil/" element={<ProfileUpdate/>}/>
                  <Route path="/usuario/faturas/" element={<UnitUserInvoiceList/>}/>
                  <Route path="/usuario/faturas/:id" element={<UnitUserInvoiceDetail/>}/>
                </>
              }
            </Route>
          </Route>

          {is_superuser &&<Route element={<AdminBase/>}>
            <Route element={<RequireAuth/>}>
                  <Route path="/admin/dashboard" element={<AdminDashboard/>}/>
                  <Route path="/admin/dashboard/macro" element={<AdminMacroDashboard/>}/>
                  <Route path="/admin/logs" element={<LogsViewer/>}/>
                  <Route path="/admin/dashboard/rent" element={<AdminRentDashboard/>}/>
                  <Route path="/admin/company" element={<CompanyList/>}/>
                  <Route path="/admin/company/:id" element={<CompanyDetail/>}/>
                  <Route path="/admin/transaction" element={<TransactionList/>}/>
                  <Route path="/admin/company-rate" element={<CompanyRateList/>}/>
                  <Route path="/admin/company-rate/:id" element={<CompanyRateDetail/>}/>
                  <Route path="/admin/user" element={<UserAdminList/>}/>
                  <Route path="/admin/webhooks" element={<WebhookList/>}/>
                  <Route path="/admin/invoice" element={<CustomerInvoiceList/>}/>
                  <Route path="/admin/invoice/:id" element={<CustomerInvoiceDetail/>}/>
                  <Route path="/admin/rent-contract" element={<RentContractAdminList/>}/>
                    <Route path="/admin/faturas" element={<AdminInvoiceList />}/>
                    <Route path="/admin/repasses" element={<AdminSignedRecipientTransferList />}/>
                    <Route path="/admin/faturas/:id" element={<InvoiceDetail/>}/>
                    <Route path="/admin/repasses/:id" element={<SignedRecipientTransferDetail/>}/>
                    <Route path="/admin/contratos/:id" element={<RentForm/>} />
                    <Route path="/admin/ai-provider-config" element={<AIProviderConfigList/>}/>
                    <Route path="/admin/ai-provider-config/create" element={<AIProviderConfigForm/>}/>
                    <Route path="/admin/ai-provider-config/:id" element={<AIProviderConfigForm/>}/>
                    <Route path="/admin/funcionalidades" element={<FeatureList/>}/>
                    <Route path="/admin/funcionalidades/create" element={<FeatureForm/>}/>
                    <Route path="/admin/funcionalidades/:id" element={<FeatureForm/>}/>
                    <Route path="/admin/planos" element={<PlanList/>}/>
                    <Route path="/admin/planos/create" element={<PlanForm/>}/>
                    <Route path="/admin/planos/:id" element={<PlanForm/>}/>
                    <Route path="/admin/company/:id/plano" element={<CompanyPlanManager/>}/>
                    <Route path="/admin/ai-assistant" element={<AdminAIAssistant/>}/>
                    <Route path="/admin/tickets" element={<AdminTicketList/>}/>
                    <Route path="/admin/tickets/dashboard" element={<AdminTicketDashboard/>}/>
                    <Route path="/admin/tickets/knowledge" element={<AIKnowledgeBase/>}/>
                    <Route path="/admin/tickets/:id" element={<AdminTicketDetail/>}/>
            </Route>
          </Route>}

          <Route element={<Base/>}>
            <Route element={<RequireAuth/>}>
              {user &&
                <>
                  {user?.perm_dashboard &&<Route path={'/'} element={<Dashboard/>}/> }
                    <Route path="/financeiro/dashboard" element={<CashFlowDashboard/>}/>
                    <Route path="/financeiro/recebimentos" element={<ReceivablesList/>}/>
                    <Route path="/financeiro/recebimentos/criar" element={<ReceivablesCreate/>}/>
                    <Route path="/financeiro/recebimentos/:id" element={<ReceivablesDetail/>}/>
                    <Route path="/financeiro/contatos" element={<ContactsList/>}/>
                    <Route path="/financeiro/contatos/:id" element={<FinancialContactDetail/>}/>
                    <Route path="/financeiro/pagamentos" element={<PaymentsList/>}/>
                    <Route path="/financeiro/pagamentos/criar" element={<PaymentsCreate/>}/>
                    <Route path="/financeiro/pagamentos/:id" element={<PaymentsDetail/>}/>
                    <Route path="/financeiro/configuracoes" element={<FinancialConfig/>}/>
                  <Route path="/perfil" element={<ProfileUpdate/>}/>
                  <Route path="/perfil/alterar-senha" element={<ChangePassword/>}/>
                  {/*<Route path="/documentos" element={<DocumentList/>}/>*/}
                  <Route path="/notificacoes" element={<NotificationList/>}/>

                  {perm_financial === true ? (
                    <>
                      <Route path="/faturas" element={<InvoiceList/>}/>
                      <Route path="/faturas/:id" element={<InvoiceDetail/>}/>
                      <Route path="/cobranca" element={<ChargeList/>}/>
                      <Route path="/cobranca/criar" element={<ChargeCreate/>}/>
                      <Route path="/cobranca/:id" element={<ChargeDetail/>}/>
                      <Route path="/assinatura" element={<DocSignGate />}/>
                      <Route path="/assinatura/enviar-documento" element={<DigitalSignatureCreate />}/>
                      <Route path="/assinatura/:id" element={<DigitalSignatureView />}/>
                      <Route path="/modelo" element={<TemplateList />}/>

                      <Route path="/encargos-locaticios" element={<RentalChargesList/>}/>
                      <Route path="/pagamento/encargos" element={<RentalChargePayment/>}/>
                      <Route path="/reajustes" element={<Reajust/>}/>
                      <Route path="/dimob" element={<Dimob/>}/>
                      <Route path="/dimob/:id" element={<DimobDetail/>}/>

                      {getCondoType() === 'CONDO' ? (
                        <>
                          <Route path="/despesas" element={<ExpenseList/>}/>
                          <Route path="/despesas/criar" element={<ExpenseCreate/>}/>
                          <Route path="/despesas/:id/editar" element={<ExpenseUpdate/>}/>
                          <Route path="/despesas/:id" element={<ExpenseDetails/>}/>
                        </>
                      ) : (
                        <Route path="*" element={<Navigate to="/" replace/>}/>
                      )}

                      {(getCondoType() !== 'CONDO') ? (
                        <>
                          {(getCondoType() === 'BUSINESS' || getCondoType() === 'RENTAL_CAR')?
                              <Route path="/contratos/" element={<RentContractList/>}/>
                              :
                              <Route path="/contratos/" element={<RentList/>}/> }

                          <Route path="/contratos/v2/" element={<RentContractList/>}/>

                          <Route path="/tarefas/" element={<TaskCenter/>}/>

                          <Route path="/contratos/criar" element={<RentForm/>}/>
                          <Route path="/contratos/:id" element={<RentForm/>}/>

                            <Route path="/contato/:id" element={<ContactDetail/>}/>

                          <Route path="/beneficiarios/" element={<RentRecipientList/>}/>
                          <Route path="/contatos/socios" element={<BusinessPartnerList/>}/>
                          <Route path="/contatos/funcionarios" element={<EmployeeList/>}/>
                          <Route path="/contatos/fornecedores" element={<SupplierList/>}/>
                          <Route path="/beneficiarios/criar" element={<RentRecipientForm/>}/>

                          <Route path="/beneficiarios/:id" element={<RentRecipientDetail/>}/>
                          {/*<Route path="/beneficiarios/:id" element={<RentRecipientForm/>}/>*/}

                          <Route path="/repasses/" element={<SignedRecipientTransferList/>}/>
                          <Route path="/repasses/:id" element={<SignedRecipientTransferDetail/>}/>
                          <Route path="/relatorio-geral" element={<RentReportList/>}/>
                        </>
                      ) : (
                        <Route path="*" element={<Navigate to="/" replace/>}/>
                      )}
                    </>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}

                  {perm_bank === true ? (
                    <>
                      <Route path="/banco" element={<BankHub/>}/>
                      <Route path="/extrato" element={<BankStatement/>}/>
                      <Route path="/financeiro/extrato" element={<NewBankStatement/>}/>
                      <Route path="/financeiro/contas-bancarias" element={<BankAccountList/>}/>
                      <Route path="/financeiro/contas-bancarias/:id/extrato" element={<StatementEntries/>}/>
                      <Route path="/financeiro/contas-bancarias/:id/importacoes" element={<ImportHistory/>}/>
                      <Route path="/transferencia" element={<BankTransfer/>}/>
                      <Route path="/transferencia/ted/" element={<BankTransferDetailTed/>}/>
                      <Route path="/transferencia/pix/" element={<BankTransferDetailPix/>}/>
                      <Route path="/transferencia/:id/recibo/ted" element={<BankTransferReceiptTed/>}/>
                      <Route path="/transferencia/:id/recibo/pix" element={<BankTransferReceiptPix/>}/>
                      <Route path="/pagamento" element={<Payment/>}/>
                      <Route path="/pagamento/list" element={<PaymentList/>}/>
                    </>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}

                  {perm_config === true ? (
                    <Route element={<Settings/>}>
                      <Route path={'/configuracoes/contas'} element={<CondoList/>}/>
                      <Route path={'/configuracoes/usuarios'} element={<UserList />}/>
                      {getCondoType() !== 'CONDO' && <Route path={'/configuracoes/categorias'} element={<CategoryFee />}/> }
                      <Route path={'/configuracoes/dadosconta'} element={<CondoUpdate/>}/>
                      <Route path="/limites" element={<LimitBankDetail/>}/>
                      {(perm_expense === true && getCondoType() === 'CONDO') ?
                        <>
                          <Route path={'/configuracoes/bloco'} element={<BlockFormSet/>}/>
                          <Route path={'/configuracoes/categorias'} element={<Category/>}/>
                        </>
                          :
                          <Route path={'/configuracoes/categorias'} element={<CategoryFee />}/>
                      }

                      <Route path={'/configuracoes/relatorios'} element={<Report />}/>
                      <Route path={'/configuracoes/documentos'} element={<DocumentList/>}/>
                      <Route path={'/configuracoes/whatsapp'} element={<WhatsappConfig/>}/>
                    </Route>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}
                  {getCondoType() === 'BUSINESS'  &&
                          <>
                            <Route path={'/clientes'} element={<CustomerList/>}/>
                            <Route path={'contatos/clientes'} element={<ClientList/>}/>
                            <Route path={'/alugueis/imoveis/criar'} element={<UnitForm/>}/>
                            <Route path={'/alugueis/imoveis/:id/editar'} element={<UnitForm/>}/>
                          </> }

                  {getCondoType() === 'RENT' ? (
                    <>
                      <Route path={'/alugueis/imoveis'} element={<UnitList/>}/>
                      <Route path={'/alugueis/imoveis/criar'} element={<UnitForm/>}/>
                      <Route path={'/alugueis/imoveis/:id/editar'} element={<UnitForm/>}/>
                    </>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}
                  <Route path="/vistoria" element={<InspectionList/>}/>
                  <Route path="/vistoria/:id" element={<InspectionDetails/>}/>

                  {getCondoType() === 'CONDO' ? (
                    <>
                      <Route path={'/condominio/imoveis'} element={<UnitList/>}/>
                      <Route path={'/condominio/imoveis/criar'} element={<UnitForm/>}/>
                      <Route path={'/condominio/imoveis/:id/editar'} element={<UnitForm/>}/>
                    </>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}

                  {perm_maintenance === true ? (
                    <>
                      <Route path="/manutencao" element={<MaintenanceCalendar/>}/>
                      <Route path="/manutencao/servicos" element={<ServiceList/>}/>
                      <Route path="/manutencao/servicos/cadastrar" element={<ServiceCreate/>}/>
                      <Route path="/manutencao/servicos/prestador/:id" element={<ServiceDetailAndUpdate/>}/>
                    </>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}

                  {perm_booking === true ? (
                    <>
                      <Route path="/reserva" element={<BookingCalendar/>}/>
                      <Route path="/reserva/areas" element={<BookingAreaList/>}/>
                    </>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}

                  {perm_billboard === true ? (
                    <Route path="/avisos" element={<BillboardList/>}/>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}

                  {perm_complain === true ? (
                    <Route element={<ComplaintMain/>}>
                      <Route path="/reclamacoes" element={<ComplaintList/>}/>
                      <Route path="/reclamacoes/registrar" element={<ComplaintCreate/>}/>
                      <Route path="/reclamacoes/detalhes/:id" element={<ComplaintDetailandUpdate/>}/>
                      <Route path="/reclamacoes/categorias/" element={<ComplaintCategory/>}/>
                    </Route>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}

                  {perm_management === true ? (
                    <Route path="/portaria" element={<ManagementList/>}/>
                  ) : (
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                  )}

                  {!!is_superuser &&
                    <Route path="/user/impersonate" element={<Impersonate/>}/>
                  }
                </>
              }

              <Route path="*" element={user && <NoMatch/>}/>
            </Route>
          </Route>
          <Route path="*" element={user && <NoMatch/>}/>
        </Routes>
      </LocalizationProvider>
    </>
  )
}

export default App
